import * as Sentry from '@sentry/gatsby'

Sentry.init({
  // __SENTRY_DSN__ defined in webpack from SENTRY_DSN by gatsby-node.js
  dsn: __SENTRY_DSN__,
  integrations: [
    ...(process.env.NODE_ENV !== 'development' ? [Sentry.browserTracingIntegration()] : []),
    Sentry.extraErrorDataIntegration({
      // increase depth to capture response headers and body (for fetch error)
      depth: 4,
    }),
  ],
  // __SENTRY_ENVIRONMENT__ defined in webpack from SENTRY_ENVIRONMENT by gatsby-node.js
  ...(!!__SENTRY_ENVIRONMENT__ && {
    environment: __SENTRY_ENVIRONMENT__,
  }),
  // __SENTRY_RELEASE__ defined in webpack from SENTRY_RELEASE by gatsby-node.js
  release: __SENTRY_RELEASE__,
  sampleRate: 1.0,
  sendDefaultPii: true,
  tracesSampleRate: 0.1,
})
